import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['Marcos', 'Lucía', 'Federico', 'Ana', 'Gastón', 'Sofía', 'Pablo', 'Valentina', 'Facundo', 'Camila'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initial = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      setTimeout(showPopup, Math.random() * 5000 + 10000);
    }, 15000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-142">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white border-4 border-[#FF6B00] rounded-xl shadow-2xl p-4 max-w-xs flex items-center gap-4" data-id="element-143">
          <div className="bg-[#FFF4ED] p-2 rounded-full" data-id="element-144">
            <ShoppingBagIcon className="w-6 h-6 text-[#FF6B00]" data-id="element-145" />
          </div>
          <div data-id="element-146">
            <p className="text-sm font-black text-[#0B1F3A] uppercase" data-id="element-147">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-[#FF6B00] font-bold uppercase tracking-wide" data-id="element-148">
              acaba de comprar el Kit Completo
            </p>
            <p className="text-[10px] text-gray-500 font-bold mt-1 uppercase" data-id="element-149">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}